import { Injectable, TemplateRef, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<any[]>([]);

  // Push new Toasts to array with content and options
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const toast = { textOrTpl, ...options };
    this.toasts.update(current => [...current, toast]);

    // Auto-hide toast after delay
    if (options.autohide !== false) {
      const delay = options.delay || 5000;
      setTimeout(() => {
        this.remove(toast);
      }, delay);
    }
  }

  // Callback method to remove Toast DOM element from view
  remove(toast: any) {
    this.toasts.update(current => current.filter(t => t !== toast));
  }

  // Clear all toasts
  clear() {
    this.toasts.set([]);
  }

  // Convenience methods
  success(message: string) {
    this.show(message, {
      classname: 'bg-success text-light',
      delay: 5000,
      headertext: 'Success',
    });
  }

  error(message: string) {
    this.show(message, {
      classname: 'bg-danger text-light',
      delay: 5000,
      headertext: 'Error',
    });
  }

  warning(message: string) {
    this.show(message, {
      classname: 'bg-warning text-dark',
      delay: 5000,
      headertext: 'Warning',
    });
  }

  info(message: string) {
    this.show(message, {
      classname: 'bg-info text-light',
      delay: 5000,
      headertext: 'Info',
    });
  }
}
